import { render, staticRenderFns } from "./RegistrationComplete.vue?vue&type=template&id=ca79924c&scoped=true&"
import script from "./RegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./RegistrationComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationComplete.vue?vue&type=style&index=0&id=ca79924c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca79924c",
  null
  
)

export default component.exports